//  -*-web-*-

export class ChartOptions {
    
    constructor(settings, data, size, animate=true) {
	this.reference = {
	    title: "Beta Version!",
	    animation: { duration: 800, startup: false, easing: "out" },
	    titleTextStyle: {color: "#bbbbbb", fontSize: 26,
			     fontName: "Arial, Helvetica, sans-serif"},
	    legendTextStyle: {color: "#888888", fontSize: 12},
	    legend: "top",
	    chartArea: {width:"86%", height:"75%"},
	    //chartArea: {left: 50, top: 50, width:"90%", height:"70%"},
	    colors: ["red"], // default color
	    interpolateNulls: true,
	    curveType: "function",
	    lineWidth: 0.5,
	    reverseCategories: true,
	    annotations: { style: 'line' },
	    seriesType: "line",
	    isStacked: true, // For area series
	    backgroundColor: {stroke: "#555555", strokeWidth: 0, fill: "white"} ,
	    pointSize: 0,
	    enableInteractivity: true, 
	    hAxis: {textStyle: {fontSize: 13}, 
		    viewWindow: {max: 100, min: 0}},
	    //viewWindow: {max: "auto", min: "auto"}},
	    vAxes: {
		0: {logScale: false, viewWindowMode: "explicit",
		    gridlines: {color: "white"},	
		    textStyle: {color: "white", fontSize: 1},
		    viewWindow: {max: 3, min: 0}},
		1: {logScale: false, viewWindowMode: "explicit",
		    textPosition: "out",
		    textStyle: {fontSize: 13}, 
		    viewWindow: {max: 400, min: 300}}
	    },	
	    series: null, // will be filled later
	};
	this.opts = {
	    matches: {color: "GoldenRod", targetAxisIndex: 1},
	    market: {color: "DarkSlateGray", pointSize: 0, lineWidth: 1.5, 
		     curveType: "none", targetAxisIndex: 1},
	    peak: {color: "RoyalBlue", pointSize: 3, lineWidth: 0, targetAxisIndex: 1},
	    valley: {color: "FireBrick", pointSize: 3, lineWidth: 0, targetAxisIndex: 1},
	    winners: {type: "bars", color: "LightSteelBlue", targetAxisIndex: 0},
	    winners_avg: {enableInteractivity: false, color: "#777777",
			  targetAxisIndex: 0, lineWidth: 2},
	    ma: {lineWidth: 2, targetAxisIndex: 1},
	    hi_stdev: {type: "area", color: "green", areaOpacity: 0.1, 
		       enableInteractivity: false, lineWidth: 0, targetAxisIndex: 1},
	    mean: {type: "area", color: "green", areaOpacity: 0.1,
		   enableInteractivity: false, lineWidth: 0.5, targetAxisIndex: 1},
	    lo_stdev: {type: "area", color: "green", areaOpacity: 0.0, 
		       enableInteractivity: false, lineWidth: 0, targetAxisIndex: 1},
	};
	for (let key in this.opts) {
	    if (key !== 'matches')
		this.opts[key].visibleInLegend = false;
	}
	this.options = null;
	this.update(settings, data, size, animate);
    };

    update(settings, data, size, animate=true) {
	const factor = 0.95;
	const aspect = 0.66;
	let width = size.width*factor;
	let height = width*aspect;

	var options = this.reference; // reference basic options
	options.title = settings.market;
	options.width = width;
	options.height = height;
	options.series = [];
	if (!animate) options.animation.duration = 0;

	let i = 0;
	// First we draw the samples
	if ("matches" in settings) {
	    let len = settings.matches;
	    for (i = 0; i < len; i++) {
		options.series.[i] = this.opts.matches;
	    }
	}
	// Then we draw the stdev distribution areas
	if ("stdev" in settings) {
	    options.series[i++] = this.opts["lo_stdev"];
	    options.series[i++] = this.opts["mean"];
	    options.series[i++] = this.opts["hi_stdev"];
	}
	// Draw mean average (MA) lines - make them thinner if many of them
	if ("ma" in settings) {
	    var mavtab = settings.ma;
	    var tablen = mavtab.length;
	    this.opts.ma.lineWidth = Math.max(0.5, Math.min(2.5, 12/tablen));
	    for (let k in mavtab) {
		let opt = JSON.parse(JSON.stringify(this.opts.ma)); // clone
		opt['color'] = this.getMAColor(k, tablen);
		options.series[i++] = opt;
	    }
	}
	// Set point sizes and line thickness
	const ncols = data.rows.length;
	var point_size = Math.max(2, Math.min(7, options.width/(1.5*ncols)));

	options.series[i++] = this.opts.market;
	options.series[i-1].lineWidth = Math.max(1, Math.min(2, options.width/(3*ncols)));
	options.series[i-1].pointSize = point_size*0.7;

	options.series[i++] = this.opts.peak;
	options.series[i-1].pointSize = point_size;
	
	options.series[i++] = this.opts.valley;
	options.series[i-1].pointSize = point_size;

	options.series[i++] = this.opts.winners;
	options.series[i++] = this.opts.winners_avg;

	// Vertical axis
	const y_zoomlevel = 1;
	const range = this.getDataRange(settings.forecast, data);
	let mid = range.min + (range.max - range.min)/2;
	let vRange = (range.max - range.min)*y_zoomlevel;
	options.vAxes[1].viewWindow.min = parseInt(mid - vRange/2);
	options.vAxes[1].viewWindow.max = parseInt(mid + vRange/2);
	
	// Horisontal axis
	const x_zoomlevel = 1;
	let hRange = parseInt(settings.forecast) + parseInt(settings.history) + 2;
	options.hAxis.viewWindow.max = hRange;
	options.hAxis.viewWindow.min = hRange*(1 - x_zoomlevel);

	// Adjust font size to chart size
	var ws = isNaN(width) ? height/aspect : width;
	options.titleTextStyle.fontSize = this.fontSize("h1", ws);
	options.legendTextStyle.fontSize = 
	    Math.min(12, options.titleTextStyle.fontSize/2.4);
	//document.getElementById("header_div").style.fontSize = fontSize("h2", ws)+"px";

    	//console.log(options);
	this.options = options;
    }
    
    // --------------------------------------------------------------------
    // Compute fontsize for different chart sizes
    // --------------------------------------------------------------------
    fontSize(kind, width)
    {
	if (kind === "h1")
    	    return Math.max(12, Math.min(24, width/42));
	else if (kind === "h2")
    	    return Math.max(4, Math.min(14, width/100));
    }

    // --------------------------------------------------------------------
    // Compute and return an RGB string for different types of MA
    // --------------------------------------------------------------------
    getMAColor(pos, len) {
	// Compute different casts of blue for the MA lines
	var max = 230;
	var min = 180;
	var bdomina = 50;
	var delta = max - min;
	var blue = min + Math.round(delta*(len-pos)/(len-1));
	blue = Math.max(0, Math.min(blue, 255));
	let redgreen = Math.max(0, blue-bdomina);
	var bhex = blue.toString(16);
	var rghex = redgreen.toString(16);
	if (bhex.length < 2) bhex = "0" + bhex; 
	if (rghex.length < 2) rghex = "0" + rghex; 
	return "#" + rghex + rghex + bhex;
    }

    // --------------------------------------------------------------------
    // 
    // --------------------------------------------------------------------
    getColumnRange(data, col) {
	let ret = { min: null, max: null };
	var ncols = data.rows.length;
	for (let row = 0; row < ncols; row++) { 
	    let val = data.rows[row].c[col].v;
	    if (val !== null && !isNaN(val)) {
		ret.min = ret.min === null? val : Math.min(val, ret.min);
		ret.max = ret.max === null? val : Math.max(val, ret.max);
	    }
	}
	return ret;
    }
    
    
    // --------------------------------------------------------------------
    // Compute the number of peaks/valleys based on the matching length
    // --------------------------------------------------------------------
    len2pv(data, matchlen, forecastlen) {
	var pos = { "peak": 0, "valley": 0 };
	var nrows = data.cols.length;
	var len = pos.length;
	var hits = 1;
	for (let i = nrows - 1; i >= 0; i--) {
	    var id = data.cols[i].id;
	    for (let key in pos) {
		if (id === key) pos[key] = i;
		hits++;
	    }
	    if (hits >= len) return;
	}
	
	// Count peaks and valleys
	var ncols = data.rows.length;
	var count = 0;
	var max = Math.min(ncols, forecastlen + matchlen + 1);
	for (var i = forecastlen+1; i < max; i++) {
	    if (data.rows[i].c[pos.peak] !== null) count++;
	    else if (data.rows[i].c[pos.valley] !== null) count++;
	}
	return count;
    }
    
    // --------------------------------------------------------------------
    // 
    // --------------------------------------------------------------------
    getDataRange(forecastLen, data) {
	// We manually compute and set the max/min values for the chart
	var nrows = data.cols.length;
	var mmin = 999999999;
	var mmax = -mmin;
	var closeColumn = null;
	var closeRange = null;
	for (let i = 1; i < nrows; i++) {
	    let id = data.cols[i].id;
	    if (id === "close") {
		closeColumn = i;
		closeRange = this.getColumnRange(data, i);
		break;
	    }
	}
	var todayVal = data.rows[forecastLen].c[closeColumn].v;
	var d = 0;
	var stdev_max = 0;
	var stdev_min = 0;
	for (var i = 1; i < nrows; i++) {
	    let id = data.cols[i].id;
	    if (id !== "winners" && id !== "median" && 
		id !== "upper" && id !== "winhist")
	    {
		d++;
		let range = this.getColumnRange(data, i);
		mmin = Math.min(range.min, mmin); // lowest
		mmax = Math.max(range.max, mmax); // highest
		stdev_max += Math.pow(range.max - todayVal, 2);
		stdev_min += Math.pow(range.min - todayVal, 2);
	    }
	}
	stdev_max = Math.sqrt(stdev_max/d);
	stdev_min = Math.sqrt(stdev_min/d);
	var dmax = Math.max(1.5*stdev_max + todayVal, closeRange.max);;
	var dmin = Math.min(todayVal - 1.5*stdev_min, closeRange.min);
	var drange = Math.abs(dmax - dmin);
	var high = Math.abs(todayVal-dmin)/Math.abs(dmax-todayVal) > 2;
	var low = Math.abs(dmax-todayVal)/Math.abs(todayVal-dmin) > 2;
	var highscale = high ? 1.1 : 1;
	var lowscale = low ? 1.3 : 1;
	let datamax = dmax + (highscale-1)*drange/2;
	let datamin = dmin - (lowscale-1)*drange/2;
	let ret = {min: datamin, max: datamax};
	return ret;
    }

    // --------------------------------------------------------------------
    // 
    // --------------------------------------------------------------------
    getOpt() {
	return this.options;
    }
}




/*
{
	    "title": "Norwegian Market (OSEBX)",
	    "animation": {
                 "duration": 1000,
                 "startup": false,
                 "easing": "out"
            },
	    "titleTextStyle": {
		"color": "#bbbbbb",
		"fontSize": 23.30952380952381,
		"fontName": "Arial, Helvetica, sans-serif"
	    },
	    "legendTextStyle": {
		"color": "#888888",
		"fontSize": 9.712301587301589
	    },
	    "legend": "top",
	    "chartArea": {
		"width": "86%",
		"height": "75%"
	    },
	    "colors": [
		"red"
	    ],
	    "interpolateNulls": true,
	    "curveType": "function",
	    "lineWidth": 0.5,
	    "reverseCategories": true,
	    "seriesType": "line",
	    "isStacked": true,
	    "backgroundColor": {
		"stroke": "#555555",
		"strokeWidth": 0,
		"fill": "white"
	    },
	    "pointSize": 0,
	    "enableInteractivity": true,
	    "hAxis": {
		"textStyle": {
		    "fontSize": 14
		},
		"viewWindow": {
		    "max": 57,
		    "min": 0
		}
	    },
	    "vAxes": {
		"0": {
		    "logScale": false,
		    "viewWindowMode": "explicit",
		    "gridlines": {
			"color": "white"
		    },
		    "textStyle": {
			"color": "white",
			"fontSize": 1
		    },
		    "viewWindow": {
			"max": 3,
			"min": 0
		    }
		},
		"1": {
		    "logScale": false,
		    "viewWindowMode": "explicit",
		    "textPosition": "out",
		    "viewWindow": {
			"max": 1118,
			"min": 956
		    }
		}
	    },
	    "series": [
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "color": "GoldenRod",
		    "targetAxisIndex": 1
		},
		{
		    "type": "area",
		    "color": "green",
		    "areaOpacity": 0,
		    "enableInteractivity": false,
		    "lineWidth": 0,
		    "targetAxisIndex": 1,
		    "visibleInLegend": false
		},
		{
		    "type": "area",
		    "color": "green",
		    "areaOpacity": 0.1,
		    "enableInteractivity": false,
		    "lineWidth": 0.5,
		    "targetAxisIndex": 1,
		    "visibleInLegend": false
		},
		{
		    "type": "area",
		    "color": "green",
		    "areaOpacity": 0.1,
		    "enableInteractivity": false,
		    "lineWidth": 0,
		    "targetAxisIndex": 1,
		    "visibleInLegend": false
		},
		{
		    "lineWidth": 2.5,
		    "targetAxisIndex": 1,
		    "visibleInLegend": false,
		    "color": "#cdcdff"
		},
		{
		    "lineWidth": 2.5,
		    "targetAxisIndex": 1,
		    "visibleInLegend": false,
		    "color": "#b4b4e6"
		},
		{
		    "lineWidth": 2.5,
		    "targetAxisIndex": 1,
		    "visibleInLegend": false,
		    "color": "#9b9bcd"
		},
		{
		    "color": "DarkSlateGray",
		    "pointSize": 4.8999999999999995,
		    "lineWidth": 2,
		    "curveType": "none",
		    "targetAxisIndex": 1,
		    "visibleInLegend": false
		},
		{
		    "color": "RoyalBlue",
		    "pointSize": 7,
		    "lineWidth": 0,
		    "targetAxisIndex": 1,
		    "visibleInLegend": false
		},
		{
		    "color": "FireBrick",
		    "pointSize": 7,
		    "lineWidth": 0,
		    "targetAxisIndex": 1,
		    "visibleInLegend": false
		},
		{
		    "type": "bars",
		    "color": "LightSteelBlue",
		    "targetAxisIndex": 0,
		    "visibleInLegend": false
		},
		{
		    "enableInteractivity": false,
		    "color": "#777777",
		    "targetAxisIndex": 0,
		    "lineWidth": 2,
		    "visibleInLegend": false
		}
	    ],
	    "width": 979,
	    "height": 646.14
	}
*/
